export default __webpack_public_path__ + "static/media/brain.392aa10f.png";